import { gql } from '@apollo/client';

export const GET_USER_INFO = gql`
  query GetUserInfo {
    getUserInfo {
      distributorCodes
      email
      familyName
      firstName
      givenName
      isHQUser
      lastName
      permissions {
        applicationName
        permissions
      }
      preferredName
      region
      roles
      sub
      userId
      userType
    }
  }
`;
